(function(){function boot(){
var BASE="https://xtrusion-overland.com/products/";var IMG="https://cdn.shopify.com/s/files/1/0262/8940/6057/files/";
var steps=Array.prototype.slice.call(document.querySelectorAll(".fstep"));
  var segs=Array.prototype.slice.call(document.querySelectorAll("#fprog .seg"));
  var result=document.getElementById("fresult");
  var back=document.getElementById("fback");
  var countEl=document.getElementById("fcount");
  var nav=document.getElementById("fnav");
  var answers={};
  var cur=0;

  function showStep(n){
    steps.forEach(function(s,i){ s.classList.toggle("active", i===n); });
    result.classList.remove("active");
    segs.forEach(function(sg,i){ sg.classList.toggle("done", i<n); });
    back.style.visibility = n===0 ? "hidden" : "visible";
    countEl.textContent="STEP "+(n+1)+" / "+steps.length;
    nav.style.display="flex";
    cur=n;
  }

  document.querySelectorAll(".opts").forEach(function(group){
    var key=group.getAttribute("data-key");
    group.querySelectorAll(".opt").forEach(function(btn){
      btn.addEventListener("click",function(){
        group.querySelectorAll(".opt").forEach(function(b){ b.classList.remove("sel"); });
        btn.classList.add("sel");
        answers[key]=btn.getAttribute("data-val");
        setTimeout(function(){
          if(cur < steps.length-1){ showStep(cur+1); }
          else { finish(); }
        },230);
      });
    });
  });

  back.addEventListener("click",function(){ if(cur>0) showStep(cur-1); });

  /* recommendation engine */
  function recommend(a){
    var cover=a.cover, use=a.use;
    // cover is the strongest constraint
    if(cover==="wantenclosed" || use==="enclosed"){
      return {key:"xo", alt:"Prefer an open rack? The <a href='"+BASE+"xtr3-bed-rack-for-ford-f150' target='_blank' rel='noopener'>XTR3</a> gives you max modularity without enclosing the bed."};
    }
    if(cover==="retrax"){
      if(use==="heavy"||use==="work") return {key:"xtr3retrax", alt:"Want it lighter? The <a href='"+BASE+"xtr1-bed-rack-for-retrax-xr-cover-ford-f-150' target='_blank' rel='noopener'>XTR1 Retrax</a> build saves weight and cost."};
      return {key:"xtr1retrax", alt:"Hauling heavy, distributed gear? Step up to the <a href='"+BASE+"xtr3-bed-rack-for-retrax-ford-f-150' target='_blank' rel='noopener'>XTR3 Retrax</a> build."};
    }
    if(cover==="softtopper"){
      if(a.bed==="8.0") return {key:"xtr3soft", alt:"The XTR3 Soft Topper build is the rack we list for 8 ft beds."};
      if(use==="heavy"||use==="work") return {key:"xtr3soft", alt:"Lighter option: the <a href='"+BASE+"xtr1-bed-rack-for-softopper-soft-top-cover-ford-f-150' target='_blank' rel='noopener'>XTR1 Soft Topper</a> build."};
      return {key:"xtr1soft", alt:"Need more mounting real estate? See the <a href='"+BASE+"xtr3-bed-rack-for-softopper-soft-top-cover-ford-f-150' target='_blank' rel='noopener'>XTR3 Soft Topper</a> build."};
    }
    // open bed / standard cover
    if(use==="heavy"||use==="work") return {key:"xtr3", alt:"On a budget or just want bed bars? The <a href='"+BASE+"xbrs-crossbar-kit-for-ford-f-150' target='_blank' rel='noopener'>XBRS kit</a> starts at $732."};
    if(use==="water"||use==="bike") return {key:"xbrs", alt:"Want a full frame for a tent too? Move up to the <a href='"+BASE+"xtr1-bed-rack-ford-f-150' target='_blank' rel='noopener'>XTR1</a>."};
    // overland default
    return {key:"xtr1", alt:"Carrying heavier, mixed gear? Compare the <a href='"+BASE+"xtr3-bed-rack-for-ford-f150' target='_blank' rel='noopener'>XTR3</a> with 4 independent quadrants."};
  }

  var REC={
    xo:{badge:"Best for enclosed storage",t:"XO.SKLTN All-In-One Topper",d:"A modular, weather-tight topper on the same T-slot architecture — lockable storage that still mounts a rooftop tent and gear.",p:"2,550.00",img:"5-XOSKLTN-F150-1200x1200.jpg",h:"xo-skltn-all-in-one-system-ford-f150"},
    xtr1:{badge:"Best for overland & RTT",t:"XTR1 Bed Rack for F-150",d:"Our most popular rack — a clean, lightweight 4-upright frame with grab handles and off-road plates included. Perfect overland starting point.",p:"1,649.99",img:"xtr1-bed-rack-for-ford-f-150-custom-6760567.png",h:"xtr1-bed-rack-ford-f-150"},
    xtr3:{badge:"Best for heavy, mixed gear",t:"XTR3 Popular Builds + MOLLE",d:"Four independent quadrants and MOLLE-ready panels for maximum modularity and load. Mount a tent on one side, cargo on the other.",p:"2,149.99",img:"N_xu33wV.png",h:"xtr3-bed-rack-for-ford-f150"},
    xbrs:{badge:"Best value for bikes & boats",t:"XBRS CrossBar Kit for F-150",d:"Two low-profile bed bars with a full T-slot grid — the clean, affordable way to carry kayaks, bikes and baskets.",p:"732.00",img:"Bed_Rack_XBRS_F-150.png",h:"xbrs-crossbar-kit-for-ford-f-150"},
    xtr1retrax:{badge:"Best for Retrax XR & EQ covers",t:"XTR1 for Retrax XR — F-150",d:"Bolts straight into your Retrax XR or EQ rails for a rattle-free mount, with the lightweight XTR1 frame.",p:"1,649.99",img:"xtr1-bed-rack-for-retrax-xr-cover-ford-f-150-4290965.jpg",h:"xtr1-bed-rack-for-retrax-xr-cover-ford-f-150"},
    xtr3retrax:{badge:"Best for Retrax + heavy gear",t:"XTR3 for Retrax XR — F-150",d:"Tonneau-compatible XTR3 with four quadrants — integrates with your Retrax XR or EQ rails and carries maximum distributed load.",p:"2,149.99",img:"xtr3-bed-rack-for-retrax-xr-cover-ford-f-150-5473009.png",h:"xtr3-bed-rack-for-retrax-ford-f-150"},
    xtr1soft:{badge:"Best for soft toppers",t:"XTR1 for Soft Topper — F-150",d:"XTR1 angled at 13.3° to match the sidewalls of Softopper, FasTop and Bestop toppers. Most toppers can't fold down with the rack installed.",p:"1,649.99",img:"xtr1-bed-rack-for-soft-top-cover-toyota-tundra-7149997.png",h:"xtr1-bed-rack-for-softopper-soft-top-cover-ford-f-150"},
    xtr3soft:{badge:"Best for soft toppers + gear",t:"XTR3 for Soft Topper — F-150",d:"Soft-topper-compatible XTR3 (also offered for 8 ft beds) with four quadrants — enclosed canvas storage plus maximum accessory mounting.",p:"2,249.99",img:"xtr3-bed-rack-for-soft-top-cover-ford-ranger-8455282.png",h:"xtr3-bed-rack-for-softopper-soft-top-cover-ford-f-150"}
  };

  function finish(){
    var r=recommend(answers);
    var d=REC[r.key];
    document.getElementById("fr-badge").textContent=d.badge;
    document.getElementById("fr-title").textContent=d.t;
    document.getElementById("fr-desc").textContent=d.d;
    document.getElementById("fr-price").textContent="From $"+d.p;
    document.getElementById("fr-img").src=IMG+d.img;
    document.getElementById("fr-img").alt=d.t;
    var link=document.getElementById("fr-link");
    link.href=BASE+d.h;
    var fitNote = answers.year && answers.bed ? "Fits your "+answers.year+" F-150 · "+answers.bed+" ft bed. " : "";
    if(answers.bed==="8.0" && r.key!=="xtr3soft" && r.key!=="xbrs"){ fitNote="Heads up: this rack isn't listed for 8 ft beds yet — call <a href='tel:+13163300024'>(316) 330-0024</a> or email <a href='mailto:support@xtrusion-overland.com'>support@xtrusion-overland.com</a> and we'll confirm an 8 ft build. "; }
    var extra = answers.cover==="retrax" ? " Running Roll-N-Lock or Pace Edwards instead? Call <a href='tel:+13163300024'>(316) 330-0024</a> or email <a href='mailto:support@xtrusion-overland.com'>support@xtrusion-overland.com</a> to confirm fit." : "";
    document.getElementById("fr-alt").innerHTML=fitNote+(r.alt||"")+extra;
    steps.forEach(function(s){ s.classList.remove("active"); });
    segs.forEach(function(sg){ sg.classList.add("done"); });
    result.classList.add("active");
    nav.style.display="none";
  }

  document.getElementById("fr-restart").addEventListener("click",function(){
    answers={};
    document.querySelectorAll(".opt.sel").forEach(function(b){ b.classList.remove("sel"); });
    showStep(0);
  });

  showStep(0);
}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();})();
